/*
  A simple model + API integration module to handle the order
*/
import axios from 'axios';

require('es6-promise').polyfill();

const endPoint = '/cart.json';
const addEndPoint = '/cart/add.js';
const updateEndPoint = '/cart/change.js';
const updateMultipleEndPoint = '/cart/update.js';
const CURRENCY_SYMBOL = '$';
const shippingCost = 500;
const freeShippingMinimum = 5000;

const callbacks = [];

const state = {
  cart: {},
  dotAnimationTimeout: null,
  isFetching: false,
};

const track = function trackCartModalChange() {
  // hook tracking functions here
};

const getFrequencyUnit = function getCartFrequencyUnit() {
  return 'Weeks';
};

const getDefaultFrequency = function getDefaultCartFrequency() {
  return 4;
};

const triggerCallbacks = function triggerCartModalCallbacks(data) {
  callbacks.forEach((callback) => {
    callback(data);
  });
};

const onDataFetch = function onCartModelDataFetch(response) {
  state.cart = response.data;
  triggerCallbacks(response.data);
};

const stylePrice = function styleCartPrice(price) {
  if (!price) {
    return 'Free';
  }

  return `${CURRENCY_SYMBOL}${(price * 0.01).toFixed(2).replace('.00', '')}`;
};

const addCallback = function addCartModelCallback(callback) {
  callbacks.push(callback);
};

const getState = function getCartState() {
  return state.cart;
};

const fetch = function fetchCart(callback) {
  state.isFetching = true;
  axios.get(endPoint, {
    headers: {
      'Cache-Control': 'no-store',
      Pragma: 'no-cache',
    },
  })
    .then((data) => {
      state.isFetching = false;
      onDataFetch(data); // eslint-disable-line no-use-before-define
      if (callback) {
        callback();
      }
    });
};

const update = function updateCartItem(props = {}, shouldDoCallback = true) {
  // console.log('UPDATE');
  // console.log(props);
  return axios.post(updateEndPoint, props)
    .then((response) => {
      // console.log('RESPONSE');
      // console.log(response);
      if (shouldDoCallback) {
        onDataFetch(response); // eslint-disable-line no-use-before-define
      }
    });
};

const updateMultiple = function updateMultipleCartItem(items = {}, shouldDoCallback = true) {
  // console.log('UPDATE ALL');
  // console.log(items);
  return axios.post(updateMultipleEndPoint, { updates: items })
    .then((response) => {
      // console.log('RESPONSE');
      // console.log(response);
      if (shouldDoCallback) {
        onDataFetch(response); // eslint-disable-line no-use-before-define
      }
    });
};

const getShipping = function getCartModalShippingCost() {
  return (
    state.cart.items_subtotal_price < freeShippingMinimum
    && state.cart.item_count > 0
  ) ? shippingCost : 0;
};

const getFinalPrice = function getFinalPrice() {
  const subtotal = state.cart.items_subtotal_price;
  const shipping = getShipping();

  return subtotal + shipping;
};

// NOTE: supports line, falls back to id
const remove = function removeFromCart(props = {}) {
  const removeProps = {
    ...(props.line ? { line: props.line } : { id: props.id }),
    quantity: 0,
  };

  return update(removeProps, 0);
};

const animateDot = function animateCartDot() {
  const headerCart = document.querySelector('.js-headerCart');

  clearTimeout(state.dotAnimationTimeout);
  if (headerCart) {
    headerCart.classList.add('is-animating');
  }

  state.dotAnimationTimeout = setTimeout(() => {
    if (headerCart) {
      headerCart.classList.remove('is-animating');
    }
  }, 3200);
};

const add = function addToCart(data = {}, callback, fetchAfterAdding = true) {
  const id = data.id || 0;
  const quantity = data.quantity || 0;

  return axios.post(addEndPoint, data)
    .then((cartData) => {
      track(id, quantity);
      if (fetchAfterAdding) {
        fetch(callback);
      }
      animateDot();
    });
};

// NOTE: use both line & id for updating
const updateProps = function updateCartModelProperties(props = {}, callback, fetchAfterAdding = true) {
  const removeProps = {
    ...(props.line ? { line: props.line } : { id: props.id }),
    quantity: 0,
  };

  return update(removeProps, false).then(() => {
    add(props, callback, fetchAfterAdding);
  });
};

fetch();

export default {
  add,
  addCallback,
  fetch,
  getDefaultFrequency,
  getFrequencyUnit,
  getShipping,
  getFinalPrice,
  getState,
  remove,
  stylePrice,
  update,
  updateMultiple,
  updateProps,
};
